import { BCMSRecord, BCMSStateManagerCRUD, DisabledPrompt, useBCMSContext, useModel, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import { CenterContentContainer, ContentHeaderView, FormContainer, FormRowView, PageContainer, PageContentView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { UIButton, UIPasswordInput } from "components/ui";
import Classes from "model";
import React from "react";
import { InfoBanner } from "components/shared/views/ConfirmBannerView";
import "./styles.css";

/**
 * @function PasswordChangeRequiredPage
 * @return {React.Component}
 * @exported true
 * @description The main component for PasswordChangeRequiredPage.
 */
export default function PasswordChangeRequiredPage(props) { 
    const { nextStep } = useWorkflow() ?? {};
    const model = useModel();
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const data = { ...getDefaultData(model), ...props.data ?? {} };
    const ui = { ...getDefaultUI(), ...props.ui ?? {} };

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,
        onChange: prop => value => {
            BCMSStateManagerCRUD.init(state)
            .update([ "data", prop], { value: value })
            .submit(setState);
        },
        gotToNextStep: () => {
            nextStep();
        }
    });

    return (
        <PageContainer state={ { data, ui } } controller={ controller } className="password-change-required-page">
            <PageContent/>
        </PageContainer>
    )
}

export const getDefaultData = (model) => ({
    newPassword: { value: "" },
    confirmNewPassword: { value: "" },
});

export const getDefaultUI = () => ({
// no ui changes for now
});

  function PageContent() {
    const { data, onChange } = useStateManager();

    return (
        <PageContentView>
            <CenterContentContainer> 
                <InfoBanner iconID="ErrorIcon" text="Please update your password." />
                <ContentHeaderView text="Password Change Required" />
                <p>
                    { `Passwords must be 12 to 32 characters long and must contain all of the following: a lowercase letter (a-z),
                     an uppercase letter (A-Z), a digit (0-9), and a special character (~!@#$%^&*()[]{}<>_+-=/|\.,:;\`’”?).` }
                </p>
                <FormContainer className="small-form-width">
                    <FormRowView className="set-width" text="New Password:">
                        <UIPasswordInput value={ data.newPassword.value } dataPoint="Password_Change_Required_Page_New_Password_Input" onChange={ onChange("newPassword") } />
                    </FormRowView>
                    <FormRowView className="set-width" text="Confirm Password:">
                        <UIPasswordInput value={ data.confirmNewPassword.value } dataPoint="Password_Change_Required_Page_Confirm_Password_Input" onChange={ onChange("confirmNewPassword") } />
                    </FormRowView>
                    <FormButtonRow>
                        <DisabledPrompt>
                            <UIButton className="primary-button update-button" text="Update" dataPoint="Password_Change_Required_Page_Update_Button" />
                        </DisabledPrompt>
                    </FormButtonRow>
                </FormContainer>
            </CenterContentContainer>
        </PageContentView>
    )
  }
